import axios from "axios";
import { getToken } from "@/utils/auth";
import CryptoJS from 'crypto-js'
// date.js
export function valueInfo(key, type) {
  let vc = window.localStorage.getItem("VALUECODE");
  let VALUECODE = JSON.parse(vc); 
  let obj = VALUECODE[type].find((o) => o.value == key);
  if (obj != undefined && obj != null) {
    return obj.showinfo;
  } else {
    return key;
  }
}
export function valueInfoNull(key, type) {
  let vc = window.localStorage.getItem("VALUECODE");
  let VALUECODE = JSON.parse(vc); 
  let obj = VALUECODE[type].find((o) => o.value == key);
  if (obj != undefined && obj != null) {
    return obj.showinfo;
  } else {
    return null;
  }
}
export function valueSelectList(type) {
  let vc = window.localStorage.getItem("VALUECODE");
  let VALUECODE = JSON.parse(vc); 
  return VALUECODE[type];
}

export function evil(fn) {
  var Fn = Function;
  return new Fn(fn)();
}
export function ArrtoObj(arr) {
  let ids = [];
  for (let i = 0; i < arr.length; i++) {
    ids.push(arr[i][1]);
  }
  return ids;
}

export function getArrayLastLevelIds(arr) {
  let ids = [];
  if (arr != undefined && arr != null && arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      //获取数组最后一个元素
      ids.push(arr[i][arr[i].length - 1]);
    }
  }
  return ids;
}

export function SelectTechnicalTitleList() {
  let vc = window.localStorage.getItem("VALUECODE");
  let VALUECODE = JSON.parse(vc);
  let selectTechnicalTitleList = [];
  //处理职称
  let ZCZStechnicalTitleTypeCid = VALUECODE.ZCZStechnicalTitleTypeCid;
  let ZCZStechnicalTitleCid = VALUECODE.ZCZStechnicalTitleCid;
  ZCZStechnicalTitleTypeCid.forEach((element) => {
    let children = [];
    ZCZStechnicalTitleCid.forEach((item) => {
      if (item.valuetype2 == element.value) {
        children.push({ value: item.value, label: item.showinfo });
      }
    });
    var obj = {};
    if (children.length > 0) {
      obj = {
        value: element.value,
        label: element.showinfo,
        children: children,
      };
    } else {
      obj = { value: element.value, label: element.showinfo };
    }
    selectTechnicalTitleList.push(obj);
  });
  return selectTechnicalTitleList;
}

export function AOpenUrl(id, url,fileName) {
  var a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("target", "_blank");
    a.setAttribute('download', fileName);
    a.setAttribute("id", id);
    // 防止反复添加
    if (!document.getElementById(id)) document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}


// export function AOpenUrl(id, url,fileName) {
//   axios({
//     method: "get",
//     url:url,
//     headers: {
//       Authorization: getToken(),
//     },
//     responseType: "blob",
//   }).then((res) => {
//     const blob = new Blob([res.data]);
//     const blobURL = window.URL.createObjectURL(blob);
//     var a = document.createElement("a");
//     a.setAttribute("download", fileName);
//     a.setAttribute("href", blobURL);
//     a.setAttribute("target", "_blank");
//     a.setAttribute("id", id);
//     // 防止反复添加
//     if (!document.getElementById(id)) document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(blobURL);
//   });
// }

export function subTitle(str, len) {
  let rstr = "";
  if (str.length > len) {
    rstr = rstr.substring(0, len) + "…";
  }
  return rstr;
}

export function isEmpty(obj) {
  return obj == undefined || obj == null || obj == "";
}

export function isNull(obj) {
  return obj == undefined || obj == null;
}
export function regMag(str){
  let obj="";
  let arr = str.split("<br/>");
  for(var i=0;i<arr.length;i++) {
    if(arr[i]!=""){obj+=(i+1)+"."+arr[i]+"<br />";}
  }
  return  obj;
}

export function diffPositions(newList, oldList) { 
  let diff=false
  if(isEmpty(newList)&&isEmpty(oldList)){
    return false;
  }
  if(isEmpty(newList)&&!isEmpty(oldList)){
    diff = true;
  }
  if(!isEmpty(newList)&&isEmpty(oldList)){
    diff = true;
  }
  if(!isEmpty(newList)&&!isEmpty(oldList)&&newList.length!=oldList.length){
    diff = true;
  }

  var filter_arr=['id','add_admin_id','add_admin_name','add_depart_id','add_depart_name','add_time','edit_admin_id','edit_admin_name','edit_depart_id','edit_depart_name','edit_time','is_log'];
  newList.forEach((item,index) => {
    if(!isEmpty(oldList[index])){
      let oldItem = oldList[index]; 
        for (let key in item) {
          if(!filter_arr.includes(key)&&item[key]!=oldItem[key]){ 
            diff = true;
          }
        }
    }
  });
  return diff;
}

	// 将字符串转换为base64编码
  export function stringToBase64AES(data) {
    var key = process.env.CRYPTOKEY
    // 将密钥转换为 WordArray
    var keyWords = CryptoJS.enc.Utf8.parse(key);
    // 将数据转换为 WordArray
    var dataWords = CryptoJS.enc.Utf8.parse(data);
    // 配置加密参数
    var encrypted = CryptoJS.AES.encrypt(dataWords, keyWords, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    // 输出为 Base64 字符串
    return encrypted.toString();
	}

  
	// 身份证有限期验证
  export function verifyIdnData(ocrDate) {
    if(ocrDate == undefined || ocrDate == null || ocrDate == ""){
      return 0;
    }
      let idnarr= ocrDate.split("-");
      if(!isEmpty(idnarr[0])&&!isEmpty(idnarr[1])){
        let idsdate = new Date(idnarr[0]);
        let idedate = new Date(idnarr[1]);
        if(idsdate.getTime()>new Date().getTime()||idedate.getTime()<new Date().getTime()){
          return 1;
        } 
      }
    return 0;
	}


  export function datetoday(startdate,enddate) { 
    var begindate = new Date(Date.parse(startdate.replace(/-/g, "/")));
    var myDate = new Date();  
    var startDate = begindate.getTime();  
    var myDate = new Date(Date.parse(enddate.replace(/-/g, "/")));
    var endDate = myDate.getTime();   
    return  parseInt((endDate-startDate)/1000/3600/24);  
    }
     

export function IDCardCheck(num) {  
  num=num.replace(/^\s+|\s+$/g,""); 
  if(num!=undefined&&num!=null&&num.length>0){
  num = num.toUpperCase();
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。   
  /*if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
      return '输入的身份证号15位号码应全为数字，18位号码末位可以为数字或X，请重新输入！';
  }*/
  //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
  //下面分别分析出生日期和校验位 
  var len,re;
  len = num.length;
  if (len == 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      var arrSplit = num.match(re);
      //检查生日日期是否正确 
      var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) { 
          return '输入的身份证号里出生日期不对，请重新输入！';
      }
      else {
          //将15位身份证转成18位 
          //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0, i;
          num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
          for (i = 0; i < 17; i++) {
              nTemp += num.substr(i, 1) * arrInt[i];
          }
          num += arrCh[nTemp % 11];
          return true;
      }
  }
  if (len == 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      var arrSplit = num.match(re);
      //检查生日日期是否正确 
      var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
          //alert(dtmBirth.getFullYear());
          //alert(arrSplit[2]); 
          return '输入的身份证号里出生日期不对，请重新输入！';
      }else {
          //检验18位身份证的校验码是否正确。 
          //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
          var valnum;
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0, i;
          for (i = 0; i < 17; i++) {
              nTemp += num.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[nTemp % 11];
          if (valnum != num.substr(17, 1)) { 
              return '18位身份证的校验码不正确，请重新输入！';
          }
          return '';
      }
  }
}else{
  return '身份证号码必须填写，无身份证可以填写其他相关证件信息，如护照等';
}
  return '';
}

 
export function  IdCard(IdCard, type) {
     if (type === 1) {
         //获取出生日期
         let birthday = IdCard.substring(6, 10) + "-" + IdCard.substring(10, 12) + "-" + IdCard.substring(12, 14)
         return birthday
     }
     if (type === 2) {
         //获取性别
         if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
             return "1"
         } else {
             return "2"
         }
     }
     if (type === 3) {
         //获取年龄
         var ageDate = new Date()
         var month = ageDate.getMonth() + 1
         var day = ageDate.getDate()
         var age = ageDate.getFullYear() - IdCard.substring(6, 10) - 1
         if (IdCard.substring(10, 12) < month || IdCard.substring(10, 12) === month && IdCard.substring(12, 14) <= day) {
             age++
         }
         if (age <= 0) {
             age = 1
         }
         return age
     }
 }



// WEBPACK FOOTER //
// ./src/utils/help.js